import { Helmet } from "react-helmet";
import { ReactTagManager } from "react-gtm-ts";
import Page from "@/components/Page";
import Button from "@/components/Button";
import Chevron from "@/assets/icons/chevron.svg?react";
import { useNavigate } from "react-router-dom";
import { useOnboarding } from "@/hooks/useOnboarding";
import BrandLogo from "@/components/BrandLogo";
import Container from "@/components/Container";
import Mixpanel from "@/services/tracking";

export default function StartPage() {
  const { resetAnswers, setCurrentFlow } = useOnboarding();
  const navigate = useNavigate();

  const onStart = () => {
    resetAnswers();
    setCurrentFlow("obesity");
    Mixpanel.register({ flow: "obesity" });
    Mixpanel.track("OnboardingStarted");
    navigate("/steg/existerande-behandling");
    ReactTagManager.action({
      event: "web_onboarding_begin_questionnaire",
    });
  };

  return (
    <>
      <Helmet
        title="Blodtrycksdoktorn - Modern behandling mot övervikt"
        style={[
          {
            cssText: `
              body {
                background: var(--questionnaire-bg);
              }
            `,
          },
        ]}
      />
      <Container>
        <BrandLogo />

        <Page justifyContent="flex-end">
          <h1>Hej! Vi finns här för dig som vill ha hjälp med vikten.</h1>

          <ol>
            <li>Moderna läkemedel och stöd för hälsosamma levnadsvanor</li>
            <li>100 kr i patientavgift, frikort gäller</li>
            <li>Digital vård – när det passar dig</li>
          </ol>

          <p>Svara på några snabba frågor och se hur vi kan hjälpa dig!</p>

          <div className="text-right">
            <Button onClick={onStart} iconRight={<Chevron />}>
              Svara på frågorna
            </Button>
          </div>

          <small className="disclaimer mt-20">
            En utredning genomförs innan vi påbörjar behandling för att
            säkerställa en korrekt diagnos. Vi följer Läkemedelsverkets
            föreskrifter för medicinsk överviktsbehandling.
          </small>
        </Page>
      </Container>
    </>
  );
}
